// Step index 0 is the initial email, sent immediately on approval — it is not
// itself a "follow-up". Follow-ups are the steps that come after it, so
// follow-up numbering starts at 1 for step index 1 (step index 1 = "Follow-up
// 1", index 2 = "Follow-up 2", and so on). "Follow-up" is the user-facing name
// for what the backend still calls a "touch" (CampaignTouchLogRecord,
// campaign_send_touch, etc.) — that internal naming is unchanged, only this
// label is. Shared between the builder and the detail screen so the two never
// drift into different numbering.
export function stepLabel(index: number): string {
  return index === 0 ? 'Initial email' : `Follow-up ${index}`
}

// Same labeling, phrased for use mid-sentence (e.g. "3 days after ___").
export function stepReferencePhrase(index: number): string {
  return index === 0 ? 'the initial email' : `follow-up ${index}`
}
